export default "/kiban/_next/static/images/semiTh-252ff32205ba678a24af8f6776f27030.png";